/** Подписи стадий обязательства в UI */

export const OBLIGATION_STAGE_LABELS: Record<string, string> = {
  PREPAYMENT: 'Предоплата',
  FINAL: 'Доплата',
  FINAL_PAYMENT: 'Доплата',
  INVOICE: 'Счёт',
};

export function obligationStageLabel(stage?: string | null): string {
  const k = String(stage || '')
    .trim()
    .toUpperCase();
  if (!k) return '—';
  return OBLIGATION_STAGE_LABELS[k] ?? '—';
}

/**
 * Маппинг стадии обязательства на тип платежа в API.
 * INVOICE (legacy) трактуем как доплату / основной платёж.
 */
export function obligationStageToPaymentType(stage?: string | null): 'FINAL_PAYMENT' | 'PREPAYMENT' {
  const s = String(stage || '').toUpperCase();
  if (s === 'FINAL' || s === 'INVOICE') return 'FINAL_PAYMENT';
  if (s === 'PREPAYMENT') return 'PREPAYMENT';
  return 'PREPAYMENT';
}
